<div [class]="statsData.length == 2?'grid grid-cols-2 gap-6': 'grid grid-cols-3 gap-6'">
        <div *ngFor="let stat of statsData" class="flex flex-col gap-4">
            <app-stats [data]="stat"></app-stats>
            <app-bar-percent [percent]="stat.percent ?? 0"></app-bar-percent>
            <span class="typography-title-s">{{ stat.label }}</span>
        </div>
</div>
